<template>
  <el-dialog
    :title="name"
    :visible.sync="dialogVisible"
    top="5vh"
    width="80%"
    :before-close="handleClose"
  >
    <el-form
      :inline="true"
      ref="from"
      :model="form"
      label-width="auto"
      size="mini"
    >
      <el-form-item label="员工名称">
        <el-input v-model="form.keyword"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          plain
          @click="getUerList"
          icon="el-icon-search"
        >
          搜索
        </el-button>
      </el-form-item>
    </el-form>
    <el-row>
      <el-col :span="3">
        <user-select
          :selectType="3"
          showName="增加操作员"
          :modal="false"
          @on-select="onUserSelect"
          size="mini"
        />
      </el-col>
      <el-col :span="3">
        <el-button size="mini" @click="deleteUserRole">删除</el-button>
      </el-col>
    </el-row>
    <div style="height: 60vh">
      <el-table
        max-height="500px"
        :data="userList"
        border
        style="margin-top: 8px"
        @selection-change="handleSelectionChange"
        v-loading="loading"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column label="姓名" prop="name" width="120" />
        <el-table-column label="操作员账号" prop="username" width="120" />
        <el-table-column label="部门" prop="department_name" />
      </el-table>
      <el-pagination
        style="float: right; margin-top: 10px; margin-right: 20px"
        background
        :small="true"
        layout="prev, pager, next"
        :page-size="form.pageSize"
        :total="totalCount"
        :current-page.sync="form.page"
        @current-change="getUerList"
      >
      </el-pagination>
    </div>
  </el-dialog>
</template>

<script>
import Http from "@/components/Admin/Flow/common/Http";
import userSelect from "@/components/common/userSelect.vue";
import _ from "lodash";
export default {
  name: "RoleUserList",
  components: { userSelect },
  props: {
    id: {
      type: Number | String,
      default: null,
    },
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      userList: [],
      form: {
        id: "",
        keyword: "",
        page: 1,
        pageSize: 10,
      },
      totalCount: 0,
      loading: false,
      selection: [],
    };
  },
  mounted() {},
  watch: {
    id(n, o) {
      if (o === null) {
        return;
      }
      this.getUerList();
    },
  },
  methods: {
    getUerList() {
      if (this.id == null || this.id == 0) {
        return;
      }
      this.loading = true;
      this.form.id = this.id;
      Http.post("flow/role/getUserByRole", this.form, (res) => {
        this.userList = res.UserInfos;
        this.totalCount = res.totalCount;
      });
      this.loading = false;
    },
    handleClose() {
      this.form.keyword = "";
      this.$emit("close", false);
    },
    handleSelectionChange(data) {
      this.selection = data;
    },

    onUserSelect(data) {
      let userIds = [];
      userIds = data.map((item) => {
        return item.id;
      });
      this.loading = true;
      Http.post(
        "flow/role/addUserRole",
        { roleId: this.id, userIds },
        (res) => {
          if (res.code == 200) {
            this.$message.success(res.msg);
						this.getUerList();
          } else {
            this.$message.error(res.message);
          }
        }
      );
      this.loading = false;
    },

    deleteUserRole() {
      let userIds = this.selection.map((item) => {
				return item.id
			});
			this.loading = true;
      Http.post(
        "flow/role/deleteUserRole",
        { roleId: this.id, userIds },
        (res) => {
          if (res.code == 200) {
            this.$message.success(res.msg);
						this.getUerList();
          } else {
            this.$message.error(res.message);
          }
        }
      );
      this.loading = false;
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Admin/Config/Role/RoleUserList.vue